import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appFonts } from 'theme/App.fonts';
import { appPalette } from 'theme/App.palette';
const { AvenirNextDemi, AvenirNextLight } = appFonts;
const { black, acura_red, white } = appPalette.colors;
export const useStyles = makeStyles({
  root: {
    height: 'auto',
    margin: '0 auto',
    [theme.breakpoints.up('viewportMedium')]: {
      margin: '0',
      width: '100%',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      margin: '0 auto',
    },
    '& .MicrosoftMap': {
      zIndex: 0,
      '& #MicrosoftNav': {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        marginTop: '1.375rem',
      },
      '& .Infobox': {
        borderRadius: 0,
        border: 'none',
        padding: '0.75rem 0.9375rem',
        width: '17.875rem',
        '& .infobox-title': {
          fontFamily: AvenirNextDemi.fontFamily,
          fontSize: '1rem',
          letterSpacing: 'normal',
          lineHeight: '1.25rem',
          marginBottom: '0.1875rem',
          padding: '0',
        },
        '& .infobox-info': {
          color: black,
          padding: '0',
          fontFamily: AvenirNextLight.fontFamily,
          fontSize: '1rem',
          letterSpacing: '0.03rem',
          lineHeight: '1.5rem',
          marginBottom: '1.25rem',
        },
        '& .infobox-stalk': {
          display: 'none',
        },
        '& .infobox-actions': {
          border: 'none',
          position: 'relative',
          margin: '0',
          padding: '0',
        },
        '& .infobox-actions-list a': {
          fontFamily: AvenirNextDemi.fontFamily,
          fontSize: '0.875rem',
          letterSpacing: 'normal',
          lineHeight: '1.25rem',
          borderBottom: 0,
          color: acura_red,
          display: 'inline-block',
          textTransform: 'uppercase',
        },
      },
    },
  },
  dealerPin: {
    height: '1.875rem',
    width: '2.25rem',
  },
  searchThisAreaButton: {
    color: white,
    left: '50%',
    margin: '0 auto',
    marginTop: '2.5rem',
    padding: '0.875rem 1.25rem',
    position: 'absolute',
    transform: 'translateX(-50%)',
    zIndex: 1,
    '& span': {
      color: white,
    },
    ...(theme.themeName === 'honda' && {
      height: '2.375rem',
      '@media (hover: hover) and (pointer: fine)': {
        '&:hover': {
          backgroundColor: 'white',
        },
      },
      '& span': {
        color: 'inherit',
      },
    }),
  },
});
